module.exports = __webpack_public_path__ + "assets/img/视频@3x.c114253b.png";